import {
  Box,
  Typography,
  IconButton,
  TextField,
  Modal,
  Button,
} from "@mui/material";
import React, { useEffect, useState, useMemo } from "react";
import LinearProgress from "@mui/material/LinearProgress";
import CloseIcon from "@mui/icons-material/Close";
import { api } from "../../utils/api";
import { getFileIcon, getFileName } from "../../utils/getFileIcon";
import axios from "axios";
import { formatTimestamp } from "../../utils/formatTimeStamp";
import uploadbutton from "../../assets/images/uploadbutton.svg";
import { Delete } from "@mui/icons-material";
import { getImageUrl } from "../../utils/common";

const UploadFileBrsr = ({
  handleChange,
  //   handleDelete,
  setModalUpload,
  setUploadProgress,
  setUploadedFiles,
  title,
  name,
  setErrors,
  errors,
  uploadedFiles,
  progress,
  subText,
  open,
  setOpen,
  Uploadkey,
  formData,
  setFormData,
}) => {
  const [isDragOver, setIsDragOver] = useState(false);
  const [uploadedProgress, setUploadedProgress] = useState(0);
  const [showErrors, setShowErrors] = useState(false);
  // const [uploadedFiles, setUploadedFiles] = useState([]);
  const [img, setImg] = useState([]);
  const [doc, setDoc] = useState([]);

  console.log(uploadedFiles[Uploadkey], "uploadedFiles", Uploadkey);
  const imageFiles = uploadedFiles?.[Uploadkey]?.filter((file) =>
    ["png", "jpg", "jpeg"].includes(
      file.document.split(".").pop().toLowerCase()
    )
  );

  const documentFiles = uploadedFiles?.[Uploadkey]?.filter(
    (file) =>
      !["png", "jpg", "jpeg"].includes(
        file.document.split(".").pop().toLowerCase()
      )
  );

  const validate = () => {
    const isValid = uploadedFiles?.[Uploadkey]?.every(
      (file) => file.remarks && file.remarks.trim() !== ""
    );
    setShowErrors(true); // Trigger error display
    return isValid;
  };

  const handleFileChange = async (e) => {
    const { name, files } = e.target;
    console.log(files, "from the uiii");
    setErrors((prevErrors) => ({ ...prevErrors, [name]: [] }));

    if (!files || files.length === 0) return;

    if (uploadedFiles.length + files.length > 5) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: ["You cannot upload more than 5 files."],
      }));
      return;
    }

    const newErrors = [];
    const uploaded = [];
    const progressTracker = Array(files.length).fill(0);

    const excludedTypes = [
      "application/zip",
      "application/x-rar-compressed",
      "application/x-tar",
      "application/gzip",
      "application/x-7z-compressed",
    ];

    const excludedExtensions = [".zip", ".rar", ".tar", ".gz", ".7z"];
    const maxFileSize = 5 * 1024 * 1024; // 5 MB

    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      const fileExtension1 = file.name.toLowerCase().split(".").pop();

      // Validation for file type and size
      if (
        excludedTypes.includes(file.type) ||
        excludedExtensions.includes(`.${fileExtension1}`)
      ) {
        newErrors.push(`File type not allowed: ${file.name}`);
        continue;
      }

      if (file.size > maxFileSize) {
        newErrors.push(`File size exceeds 5MB: ${file.name}`);
        continue;
      }

      // Generate unique file name
      const timestamp = Date.now();
      const formattedTimestamp = formatTimestamp(timestamp);
      const originalFileName = file.name.split(".").slice(0, -1).join(".");
      const fileExtension = file.name.split(".").pop();
      const uniqueFileName = `${originalFileName}_${formattedTimestamp}.${fileExtension}`;
      const uniqueFile = new File([file], uniqueFileName, { type: file.type });

      const formData = new FormData();
      formData.append("files", uniqueFile);
      console.log([...formData.entries()], "pdf1", formData); // Should show the file

      console.log("formdata", formData);

      try {
        // Upload the file and track progress
        const res = await axios.post(`${api}/cloud/upload-admin`, formData, {
          onUploadProgress: (progressEvent) => {
            const percent = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            );
            progressTracker[i] = percent;

            // Update progress bar dynamically
            const overallProgress = Math.round(
              progressTracker.reduce((sum, p) => sum + p, 0) / files.length
            );
            // setUploadProgress((prev) => ({ ...prev, [name]: overallProgress }));
            setUploadedProgress(overallProgress);
          },
        });

        // uploaded.push(...res.data.urls);
        res.data.urls.forEach((url) => {
          uploaded.push({ document: url, remarks: "" });
        });
      } catch (error) {
        newErrors.push(`Failed to upload: ${file.name}`);
      }
    }

    // Reset progress and errors
    setUploadedFiles((prev) => ({
      ...prev,
      [Uploadkey]: [...(prev[Uploadkey] || []), ...uploaded],
    }));

    setUploadedProgress(0);
    console.log(newErrors, name, "1234", errors);
    if (newErrors.length > 0) {
      setErrors((prevErrors) => ({ ...prevErrors, [Uploadkey]: newErrors }));
    }

    e.target.value = null;
  };

  const handleDeleteDocument = (value, index) => {
    setUploadedFiles((prev) => ({
      ...prev,
      [Uploadkey]: prev[Uploadkey].filter((file, idx) => file !== value),
    }));
    setErrors((prevErrors) => ({
      ...prevErrors,
      [Uploadkey]: "", // or handle specific errors per file if needed
    }));
  };

  // Handle file deletion

  const handleDragOver = (e) => {
    e.preventDefault();
    setUploadProgress((prev) => ({ ...prev, [name]: "0" }));
    setUploadedProgress(0);
    setIsDragOver(true);
  };

  const handleDragLeave = () => {
    setIsDragOver(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragOver(false);
    const files = e.dataTransfer.files;
    if (files.length > 0) {
      handleFileChange({ target: { name, files } });
    }
  };

  const handleFileSubmit = () => {
    if (!validate()) return;

    if (errors?.[Uploadkey]) return;
    setModalUpload((prev) => ({
      ...prev,
      [Uploadkey]: "file",
    }));
    setFormData((prev) => ({
      ...prev,
      [Uploadkey]: uploadedFiles[Uploadkey],
    }));
  };
  console.log(
    formData,
    "formData",
    Uploadkey,
    uploadedFiles[Uploadkey],
    uploadedFiles
  );

  useEffect(() => {
    console.log("Updated formData", formData);
  }, [formData]);

  return (
    <Modal
      open={open}
      onClose={() => {
        setOpen(false);
        setErrors((prevErrors) => ({
          ...prevErrors,
          [Uploadkey]: "", // or handle specific errors per file if needed
        }));
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{
          backgroundColor: isDragOver ? "#f1f1f1" : "#fff",
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "40%",
          height: "82%",
          display: "flex",
          flexDirection: "column",
          border: "none !important",
          boxShadow: 24,
          borderRadius: "10px",
          overflowY: "auto",
          p: 2,
          mb: 1,
        }}
      >
        <Box sx={{ flex: 1, mb: 1 }}>
          <Typography variant="subtitle1" sx={{ mb: 1, mt: 0 }}>
            Upload Documents
          </Typography>

          {/* Display images */}

          <Box
            style={{
              border: "2px solid rgba(28, 72, 107, 1)",
              borderRadius: "6px",
              padding: "1rem",
              textAlign: "center",
              cursor: "pointer",
              width: "100%",
            }}
            onDragOver={handleDragOver}
            onDragLeave={handleDragLeave}
            onDrop={handleDrop}
          >
            <input
              type="file"
              hidden
              id={`upload-document-${name}`}
              name={name}
              onChange={handleFileChange}
              multiple
            />
            <label htmlFor={`upload-document-${name}`}>
              <Box display="flex" flexDirection="column" alignItems="center">
                <img src={uploadbutton} alt="Upload Icon" />
                <p
                  style={{
                    fontFamily: "Inter",
                    fontSize: "16px",
                    fontWeight: "500",
                    marginTop: "10px",
                  }}
                >
                  Drop files here or click to upload
                </p>
                <Box sx={{ width: "60%" }}>
                  <p
                    style={{
                      fontFamily: "Inter",
                      fontSize: "12px",
                      fontWeight: "400",
                      textAlign: "center",
                      marginTop: "-10px",
                      marginBottom: "-0.5rem",
                    }}
                  >
                    {subText ??
                      "Upload your file (CSV, Excel, PNG, max 5 MB, recommended size 1200x800 pixels)."}
                  </p>
                </Box>
              </Box>
            </label>
          </Box>
          {errors?.[Uploadkey] && (
            <Typography variant="body2" color="#D34040">
              {errors?.[Uploadkey]}
            </Typography>
          )}
          {uploadedFiles[Uploadkey]?.length > 0 && (
            <Box sx={{ width: "100%" }}>
              <Box display="flex" flexWrap="wrap" gap={1}>
                {[...(uploadedFiles[Uploadkey] || [])]
                  .reverse()
                  .map((fileUrl, index) => {
                    const fileExtension = fileUrl?.document.split(".").pop();
                    const fileName = getFileName(fileUrl?.document);
                    const extension = fileUrl?.document
                      ?.split(".")
                      .pop()
                      .toLowerCase();

                    // Check if it's an image
                    const isImage = ["png", "jpg", "jpeg"].includes(extension);

                    // Check if it's a document (not image)
                    const isDocument = !isImage;
                    return (
                      <Box
                        key={index}
                        sx={{
                          width: "100%",
                          marginTop: "20px",
                          border: "1px solid #b3aeae",
                          borderRadius: "10px",
                          padding: "25px",
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            gap: "10px",
                            justifyContent: "space-between",
                          }}
                        >
                          <Box
                            key={index}
                            sx={{
                              position: "relative",
                              display: "flex",
                              alignItems: "center",
                              border: "1px solid #ddd",
                              borderRadius: "4px",
                              backgroundColor: "#f9f9f9",

                              overflowX: "hidden",
                            }}
                          >
                            {isDocument ? (
                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  padding: 1,
                                  width: "100%",
                                }}
                              >
                                {getFileIcon(fileExtension)}
                                <Typography
                                  variant="caption"
                                  noWrap
                                  sx={{
                                    textOverflow: "ellipsis",
                                    overflow: "hidden",
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  {fileName}
                                </Typography>
                              </Box>
                            ) : (
                              <img
                                src={fileUrl?.document}
                                alt={`Document ${index + 1}`}
                                style={{
                                  width: "100px",
                                  height: "80px",
                                  objectFit: "cover",
                                  borderRadius: "4px",
                                }}
                              />
                            )}
                          </Box>
                          <Box>
                            <Delete
                              sx={{ color: "red", cursor: "pointer" }}
                              onClick={() =>
                                handleDeleteDocument(fileUrl, index)
                              }
                            />
                          </Box>
                        </Box>
                        <Typography sx={{ marginTop: "20px" }}>
                          Remark
                        </Typography>
                        <TextField
                          placeholder="Add Remark"
                          size="small"
                          minRows={1}
                          multiline
                          fullWidth
                          variant="outlined"
                          error={showErrors && !fileUrl.remarks}
                          helperText={
                            showErrors && !fileUrl.remarks
                              ? "Remark is required"
                              : ""
                          }
                          FormHelperTextProps={{
                            sx: {
                              marginLeft: 0,
                            },
                          }}
                          sx={{
                            "& .MuiOutlinedInput-root": {
                              "& fieldset": {
                                borderColor: "#1C486B",
                              },
                              "&:hover fieldset": {
                                borderColor: "#1C486B",
                              },
                              "&.Mui-focused fieldset": {
                                borderColor: "#1C486B",
                              },
                            },
                          }}
                          value={fileUrl.remarks}
                          onChange={(e) => {
                            const actualIndex = uploadedFiles[
                              Uploadkey
                            ].findIndex((f) => f.document === fileUrl.document);
                            const updated = uploadedFiles?.[Uploadkey]?.map(
                              (file, i) =>
                                i === actualIndex
                                  ? { ...file, remarks: e.target.value }
                                  : file
                            );

                            setUploadedFiles((prev) => ({
                              ...prev,
                              [Uploadkey]: updated,
                            }));
                          }}
                        />
                      </Box>
                    );
                  })}
              </Box>
            </Box>
          )}
          {/* {imageFiles?.length > 0 && (
            <Box sx={{ width: "100%" }}>
              <Box display="flex" flexWrap="wrap" gap={1}>
                {imageFiles?.map((fileUrl, index) => {
                  return (
                    <Box
                      key={index}
                      sx={{
                        width: "100%",
                        marginTop: "20px",
                        border: "1px solid #b3aeae",
                        borderRadius: "10px",
                        padding: "25px",
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          gap: "10px",
                          justifyContent: "space-between",
                        }}
                      >
                        <Box
                          key={index}
                          sx={{
                            position: "relative",
                            display: "flex",
                            alignItems: "center",
                            border: "1px solid #ddd",
                            borderRadius: "4px",
                            backgroundColor: "#f9f9f9",

                            overflowX: "hidden",
                          }}
                        >
                          <img
                            src={fileUrl?.document}
                            alt={`Document ${index + 1}`}
                            style={{
                              width: "100px",
                              height: "80px",
                              objectFit: "cover",
                              borderRadius: "4px",
                            }}
                          />
                        </Box>
                        <Box>
                          <Delete
                            sx={{ color: "red", cursor: "pointer" }}
                            onClick={() => handleDeleteDocument(fileUrl, index)}
                          />
                        </Box>
                      </Box>
                      <Typography sx={{ marginTop: "20px" }}>Remark</Typography>
                      <TextField
                        placeholder="Add Remark"
                        size="small"
                        minRows={1}
                        multiline
                        fullWidth
                        variant="outlined"
                        error={showErrors && !fileUrl.remarks}
                        helperText={
                          showErrors && !fileUrl.remarks
                            ? "Remark is required"
                            : ""
                        }
                        FormHelperTextProps={{
                          sx: {
                            marginLeft: 0,
                          },
                        }}
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            "& fieldset": {
                              borderColor: "#1C486B",
                            },
                            "&:hover fieldset": {
                              borderColor: "#1C486B",
                            },
                            "&.Mui-focused fieldset": {
                              borderColor: "#1C486B",
                            },
                          },
                        }}
                        value={fileUrl.remarks}
                        onChange={(e) => {
                          const actualIndex = uploadedFiles[
                            Uploadkey
                          ].findIndex((f) => f.document === fileUrl.document);
                          const updated = uploadedFiles?.[Uploadkey]?.map(
                            (file, i) =>
                              i === actualIndex
                                ? { ...file, remarks: e.target.value }
                                : file
                          );

                          setUploadedFiles((prev) => ({
                            ...prev,
                            [Uploadkey]: updated,
                          }));
                        }}
                      />
                    </Box>
                  );
                })}
              </Box>
            </Box>
          )} */}

          {(progress > 0 || uploadedProgress > 0) && (
            <Box sx={{ mt: 1, mb: 1, width: "100%" }}>
              <LinearProgress value={progress} sx={{ width: "100%" }} />
            </Box>
          )}
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            gap: "1.3rem",
            // pt: 2,
            // mt: "20%",
          }}
        >
          <Button
            variant="contained"
            sx={{
              border: "1px solid #1C486B",
              textTransform: "none",
              fontFamily: "inter",
              fontWeight: 400,
              fontSize: "16px",
              lineHeight: "24px",
              marginTop: "10%",
              color: "#0a3f73",
              backgroundColor: "transparent",
              ":hover": {
                backgroundColor: "transparent",
              },
            }}
            onClick={() => {
              setOpen(false);
              setErrors((prevErrors) => ({
                ...prevErrors,
                [Uploadkey]: "", // or handle specific errors per file if needed
              }));
            }}
          >
            Cancel
          </Button>

          <Button
            variant="contained"
            sx={{
              backgroundColor: "#0a3f73",
              textTransform: "none",
              marginTop: "10%",
              fontFamily: "inter",
              fontWeight: 400,
              fontSize: "16px",
              lineHeight: "24px",
            }}
            onClick={handleFileSubmit}
          >
            Upload
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default UploadFileBrsr;
